export interface DependencyNode {
  id: string;
  /** Display label; falls back to `id`. Used for "Other (N)" aggregates and truncated labels. */
  label?: string;
  /** Tooltip text. Holds the untruncated label, or an aggregate's member list. */
  title?: string;
  /** True for "Other (N)" aggregates; drives ring + italic rendering. */
  isAggregate?: boolean;
  x: number;
  y: number;
}

export interface DependencyLink {
  from: string;
  to: string;
  /**
   * Numeric metric driving stroke width (linearly scaled) and threshold color.
   * Unit-less; pair with `metricLabel` for display.
   *
   * On aggregate edges (`members` set) this is the member count for diagnostic
   * purposes only — neither the threshold matcher nor the width scale reads it.
   */
  value: number;
  /**
   * Raw links collapsed into this aggregate edge. Set internally by the layout
   * pipeline; never on input.
   *
   * When `members.length > 1` the renderer treats this as an aggregate:
   * paired-stripe color (min/max threshold step among members), fixed stroke
   * width, per-member tooltip. Single-member rewrites are forwarded onto `value`
   * and render as ordinary edges instead.
   */
  members?: DependencyLink[];
}

/** Aggregate edges have >1 collapsed member; ordinary edges either lack `members` or carry exactly one. */
export const isAggregateLink = (link: DependencyLink): boolean => (link.members?.length ?? 0) > 1;
